module.exports = __webpack_public_path__ + "front/img/43.084463bd.png";